/**
 * @param id
 * @returns {number}
 */
export default function extractGraphQlId(id) {
  if (!id) return '';
  const idParts = String(id).match(/\d/g);
  if (!idParts || !idParts.length) return '';
  return parseInt(idParts.join(''));
}
